<div class="mx-auto max-w-screen-2xl">
  <app-in-store></app-in-store>
  <app-companies></app-companies>
  <app-dual-pillar></app-dual-pillar>
  <app-platform-teaser></app-platform-teaser>
  <app-industries id="industry"></app-industries>
  <app-featured-case-studies></app-featured-case-studies>
</div>

<app-expertise></app-expertise>

<div class="mx-auto max-w-screen-2xl">
  <app-subscribe [place]="'front page'"></app-subscribe>
</div>

<app-try-demo></app-try-demo>
